import { normalize, denormalize, schema } from 'normalizr';

//const addNodeTypeProcessStrategy = (value: any, nodeType: ArticleNodeType | SubArticleNodeType | EntityNodeType) => {
//    let copy =cloneDeep(value);  //TODO: do shallow copy with spread(...) ??
//    let localParent = { ...parent }
//    copy.nodeType = nodeType;
//    return copy
//}

function tempID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + s4();
}

const filingSchema = new schema.Entity(
  'Filing',
  {},
  {
    idAttribute: (entity, parent) => {
      return entity.DocLink_ID > 0 ? entity.DocLink_ID : tempID();
    } //documentget is not returning doclink_id
  }
);

const documentSchema = new schema.Entity(
  'Document',
  {
    Filing: [filingSchema]
  },
  { idAttribute: 'Doc_ID' }
);

const documentGetSchema = new schema.Entity(
  'Transaction',
  {
    Document: documentSchema
  },
  {
    idAttribute: (value) => '0'
    //processStrategy: (input, parent, key) => { return addNodeTypeProcessStrategy(input, "Contract_Get") }
  }
);

const documentProcessSchema = new schema.Entity(
  'Transaction',
  {
    Document: documentSchema
  },
  {
    idAttribute: (value) => '0'
    //processStrategy: (input, parent, key) => { return addNodeTypeProcessStrategy(input, "Contract_Process") }
  }
);

const conceptOneRequestSchema = new schema.Entity(
  'Request',
  {
    DocumentGet: documentGetSchema,
    DocumentProcess: documentProcessSchema
  },
  {
    idAttribute: (value) => '0'
    //processStrategy: (input, parent, key) => { return addNodeTypeProcessStrategy(input, "ConceptOneRequest") }
  }
);

const conceptOneReplySchema = new schema.Entity(
  'Reply',
  {
    DocumentGet: documentGetSchema,
    DocumentProcess: documentProcessSchema
  },
  {
    idAttribute: (value) => '0'
    //processStrategy: (input, parent, key) => { return addNodeTypeProcessStrategy(input, "ConceptOneReply") }
  }
);

// in root ID:0 = reply from LOAD    ID:1 = transaction being built for PROCESS
export const rootSchema = new schema.Entity(
  'Root',
  {
    ConceptOneRequest: conceptOneRequestSchema,
    ConceptOneReply: conceptOneReplySchema
  },
  { idAttribute: (value) => '0' }
);

export { normalize };
export { denormalize };
